export default __webpack_public_path__ + "static/media/O_Mats_Runners.7a68c5d3.jpg";